import { HelprerContentItem } from "../../../../types/propsTypes";

export const courseReviewHelpers = {
    pageTitle: [
        {
            type: 'title',
            text: 'Отзыв о курсе'
        },
        'Отобажается на странице курса',
        {
            type: 'image',
            imgSrc: '/static/img/helper/page-title/course-review.jpg',
        }
    ] as HelprerContentItem[]
}